import update from 'immutability-helper';

import Store from '../../interfaces/Store';

export const disableInteractionsReducer = (state: Store, payload: string): Store =>
  update(state, {
    suppressInteractions: {
      $push: [payload],
    },
  });

export const enableInteractionsReducer = (state: Store, payload: string): Store => {
  const indexToRemove = state.suppressInteractions.lastIndexOf(payload);
  return update(state, {
    suppressInteractions: {
      $set: state.suppressInteractions.filter((value, index) => index !== indexToRemove),
    },
  });
};
